import { useTheme } from "@emotion/react";
import { Stack } from "@mui/material";
import LabelledOutline from "components/react-lib/generic-ui/LabelledOutline";
import Loader from "components/react-lib/generic-ui/Loader";
import Selector from "components/react-lib/generic-ui/Selector";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function ModelSelector({ model, setModel, allowEmpty = true }) {
  const theme = useTheme();

  const PROVIDER_LABEL = {
    anthropic: "Anthropic",
    google: "Google",
    openai: "Open AI",
    xai: "xAI",
  };

  const modelsState = useSelector((state) => state.collections.models);
  const [provider, setProvider] = useState("");

  useEffect(() => {
    if (modelsState && !modelsState.loading) {
      if (model) {
        if (!modelsState.idMap.hasOwnProperty(model)) {
          setModel("gpt-5");
          model = "gpt-5";
        }
        if (modelsState.idMap.hasOwnProperty(model)) {
          const provider = modelsState.idMap[model].provider;
          setProvider(provider);
        } else {
          setProvider("openai");
        }
      }
    }
  }, [modelsState]);

  useEffect(() => {
    if (modelsState && !modelsState.loading && provider) {
      const providerModels = modelsState.documents
        .filter((model) => model.provider === provider)
        .map((model) => model.name);
      if (!providerModels.includes(model)) {
        setModel("");
      }
    }
  }, [modelsState, provider, provider]);

  if (!modelsState || modelsState.loading) {
    return <Loader message="Loading models" />;
  }

  let providers = [
    ...new Set(modelsState.documents.map((model) => model.provider)),
  ];

  providers = providers.map((provider) => ({
    provider,
    label: PROVIDER_LABEL[provider],
  }));

  return (
    <LabelledOutline label="Model" rawLabelColor={theme.palette.formLabel.main}>
      <Stack spacing={2}>
        <Selector
          label="Model Provider"
          value={provider}
          setValue={setProvider}
          labelField="label"
          valueField="provider"
          options={providers}
          allowEmpty={allowEmpty}
        />
        {provider && (
          <Selector
            label="Model Name"
            value={model}
            setValue={setModel}
            labelField="label"
            valueField="name"
            allowEmpty={allowEmpty}
            options={modelsState.documents
              .filter((model) => model.provider === provider)
              .filter((model) => model.type === "multimodal/text")
              .sort((x, y) => x.name < y.name)}
          />
        )}
      </Stack>
    </LabelledOutline>
  );
}
